<div class="debug-page">
    <h2 class="debug-title">Debug référents Parc</h2>

    <div class="debug-card">
        <div class="debug-controls">
            <div class="control-group">
                <label class="control-label" for="parc-select">Parc</label>
                <select id="parc-select" class="field-select" [ngModel]="parcIdSelectionne()" (ngModelChange)="parcIdSelectionne.set($event)">
                    <option [ngValue]="null">— Sélectionner un parc —</option>
                    <option [ngValue]="7">Canteranne</option>
                    @for (parc of parcs(); track parc.id) {
                        <option [ngValue]="parc.id">{{ parc.libelle }}</option>
                    }
                </select>
            </div>

            <div class="control-group">
                <label class="control-label" for="referent-select">Type de référent</label>
                <select id="referent-select" class="field-select" [ngModel]="typeReferent()" (ngModelChange)="typeReferent.set($event)">
                    <option value="ref_production">ref_production</option>
                    <option value="ref_ensoleillement">ref_ensoleillement</option>
                </select>
            </div>

            <div class="control-group">
                <label class="control-label">Période</label>
                <app-chart-period-selector
                    [mode]="mode()"
                    [dateFin]="dateFin()"
                    (periodeChange)="onPeriodeChange($event)"
                />
            </div>

            <div class="control-group">
                <label class="control-label">&nbsp;</label>
                <button class="btn-charger" [disabled]="chargement() || parcIdSelectionne() === null" (click)="chargerDonnees()">
                    @if (chargement()) {
                        <span class="material-symbols-outlined spin">progress_activity</span>
                    } @else {
                        <span class="material-symbols-outlined">download</span>
                    }
                    Charger les données
                </button>
            </div>
        </div>

        @if (erreur()) {
            <div class="result-erreur">
                <span class="material-symbols-outlined">error</span>
                {{ erreur() }}
            </div>
        }

        @if (afficherGraphique()) {
            <app-chart-host-overlay
                class="chart-area"
                [loading]="chargementGraphique()"
                loadingLabel="Chargement du graphique..."
                ariaLabel="Graphique référent parc"
                (hostReady)="onChartReady($event)"
            />
        }

        @if (tableauLignes().length > 0) {
            <div class="tableau-header">
                @if (plageSelectionnee()) {
                    <div class="plage-badge">
                        <span class="material-symbols-outlined">filter_alt</span>
                        {{ colonnesVisibles().length }} colonne(s) sélectionnée(s)
                        <button class="plage-reset" (click)="plageSelectionnee.set(null)" title="Réinitialiser la sélection">
                            <span class="material-symbols-outlined">close</span>
                        </button>
                    </div>
                }
            </div>
            <div class="tableau-wrapper">
                <table class="tableau-mesures">
                    <thead>
                        <tr>
                            <th class="col-id col-sortable" (click)="trierPar('source')">
                                Source
                                <span class="sort-icon material-symbols-outlined" [class.active]="sortEtat()?.colonne === 'source'">{{ iconeSort('source') }}</span>
                            </th>
                            @for (col of colonnesVisibles(); track col.indexOriginal) {
                                <th class="col-valeur col-sortable" (click)="trierPar(col.indexOriginal)" [class.sorted]="sortEtat()?.colonne === col.indexOriginal">
                                    {{ col.label }}
                                    <span class="sort-icon material-symbols-outlined" [class.active]="sortEtat()?.colonne === col.indexOriginal">{{ iconeSort(col.indexOriginal) }}</span>
                                </th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="ligne-fixe ligne-ref">
                            <td class="col-id">{{ seriesLabel || 'Référent' }}</td>
                            @for (val of ligneRefVisible(); track $index) {
                                <td class="col-valeur" [class.null]="val === null">{{ fmt(val, 6) }}</td>
                            }
                        </tr>
                        <tr class="ligne-fixe ligne-somme">
                            <td class="col-id">Somme sources</td>
                            @for (val of ligneSommeVisible(); track $index) {
                                <td class="col-valeur" [class.null]="val === null">{{ fmt(val) }}</td>
                            }
                        </tr>
                        @for (ligne of lignesFiltrees(); track ligne.id) {
                            <tr>
                                <td class="col-id">{{ ligne.label }}</td>
                                @for (val of ligne.valeurs; track $index) {
                                    <td class="col-valeur" [class.null]="val === null" [class.sorted]="sortEtat()?.colonne === colonnesVisibles()[$index]?.indexOriginal">{{ fmt(val) }}</td>
                                }
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
</div>
